import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default function () {
    const root = document.querySelector(".o-eco-ganho__swiper");
    if (!root) return;

    const prevEl = root.querySelector(".o-eco-ganho__nav--prev");
    const nextEl = root.querySelector(".o-eco-ganho__nav--next");
    const paginationEl = root.querySelector(".o-eco-ganho__pagination");

    const slider = new Swiper(root, {
        modules: [Pagination, Navigation],
        slidesPerView: 1.15,
        spaceBetween: 12,
        centeredSlides: false,
        autoHeight: true,
        pagination: {
            el: paginationEl,
            type: "progressbar",
        },
        navigation: {
            prevEl,
            nextEl,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
    });

    return slider;
}
